import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../../hooks/useFetch";
import { useRefreshPersons } from "../../../../hooks/useRefreshStateHooks/useRefreshPersons";
import { Button } from "../../../../ui/Button";
import { Label } from "../../../../ui/Label/Label";
import { Input } from "../../../../ui/Input/Input";
import { SelectButton } from "../../../../ui/SelectButton/SelectButton";
import { DatePicker } from "../../../../ui/Datepicker/DatePicker";
import { DateTime } from "luxon";

type Props = {
  itemId: string | undefined;
  updateList: Function;
};

const AddAccess = ({ itemId, updateList }: Props) => {
  const actionsList = [
    { value: "issued", label: t("issued") },
    { value: "take_away", label: t("take_away") },
    { value: "replaced", label: t("replaced") },
  ];

  const typesList = [
    { value: "manual", label: t("manual_access") },
    { value: "repair", label: t("repair_access") },
    { value: "service", label: t("service_access") },
    { value: "adjustment", label: t("adjustment_access") },
  ];

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      access_token_id: "",
      status: { value: "", label: "" },
      type: { value: "", label: "" },
      at: DateTime.local().toJSDate(),
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/directories/personnels/${itemId}/access_tokens`
  );

  const doFetchPersons = useRefreshPersons();
  // Обновление списка доступов при получении ответа
  useEffect(() => {
    if (saveResponse) {
      updateList();
      doFetchPersons();
      //reset();
    }
  }, [saveResponse]);

  const onSubmit = (formData: any) => {
    console.log(formData);
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          access_token_id: formData.access_token_id,
          access_token_type: formData.type.value,
          at: formData.at,
          status: formData.status.value,
        },
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col w-full gap-1 bg-muted p-4 rounded">
        <div className="text-lg font-medium">{t("adding_access_token")}</div>
        <div className="text-sm">{t("adding_access_token_text")}</div>

        <div className="flex flex-col w-full items-end gap-4 mt-4">
          <div className="grid grid-cols-2 items-end w-full gap-4">
            <Controller
              name="access_token_id"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("access_token")}*</Label>
                  <Input {...field} />
                </div>
              )}
            />

            <Controller
              name="status"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("status")}*</Label>
                  <SelectButton
                    label={"Выберите статус"}
                    searchable={false}
                    options={actionsList}
                    value={value ? actionsList.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />

            <Controller
              name="type"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("access_token_type")}*</Label>
                  <SelectButton
                    label={"Выберите тип"}
                    searchable={false}
                    options={typesList}
                    value={value ? typesList.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />

            <Controller
              name="at"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("date")}</Label>
                  <DatePicker mode="single" className="h-10 flex" selected={value} onSelect={onChange} />
                </div>
              )}
            />
          </div>

          <Button type="submit" size={"sm"} className="mb-0.5">
            {t("save")}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddAccess;
